import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'fccd-facet-container',
  styleUrl: 'facet-container.scss',
})
export class FacetContainer {
  /**
   * The id for the element in this component.
   */
  @Prop() elementId!: string;
  /**
   * The header text.
   */
  @Prop() headerLabel: string;
  render() {
    return (
      <div role="region" aria-labelledby={this.elementId}>
        <hp5-heading size-selection="sm" tag-selection="h2" element-id={this.elementId}>
          {this.headerLabel}
        </hp5-heading>
        <div class="facet-container">
          <slot />
        </div>
      </div>
    );
  }
}
